import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedModule } from '../shared/shared.module';
import { NgxMasonryModule } from 'ngx-masonry';
import { CarouselModule } from 'ngx-owl-carousel-o';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';

import { BlogRoutingModule } from './blog-routing.module';
import { SidebarComponent } from './widgets/sidebar/sidebar.component';
import { BigpostSplitComponent } from './blog-mix-layout/bigpost-split/bigpost-split.component';
import { ColumnRightSidebarComponent } from '@blog/column-right-sidebar/column-right-sidebar.component';
import { DetailNoSidebarComponent } from './blog-detail/detail-no-sidebar/detail-no-sidebar.component';
import { MasonryGalleryModule } from 'ngx-masonry-gallery';

@NgModule({
  declarations: [
    SidebarComponent,
    BigpostSplitComponent,
    DetailNoSidebarComponent,
    ColumnRightSidebarComponent,
  ],
  imports: [
    CommonModule,
    BlogRoutingModule,
    SharedModule,
    NgxMasonryModule,
    CarouselModule,
    NgbModule,
    MasonryGalleryModule
  ]
})
export class BlogModule { }
